import { render } from "./SubmenuAiAnswers.vue?vue&type=template&id=7247e40a"
import script from "./SubmenuAiAnswers.vue?vue&type=script&lang=js"
export * from "./SubmenuAiAnswers.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__